"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeForms_de_de = void 0;
function backofficeForms_de_de() {
    return {
        "backoffice.forms.title": "Formulare",
        "backoffice.forms.subtitle": "Erstellen Sie eigene Formulare die in einer Checkin-App angezeigt werden können.",
        "backoffice.forms.empty.title": "Keine Formulare gefunden...",
        "backoffice.forms.empty.meanwhile": "In der Zwischenzeit, erstellen Sie doch einfach eigene und individuelle Formulare.",
        "backoffice.forms.empty.createform": "Neues Formular erstellen",
        "backoffice.forms.editor.requiredfields": "Kunden müssen diese Felder ausfüllen",
        "backoffice.forms.editor.resetform": "Formular zurücksetzen",
        "backoffice.forms.tooltip.switchtranslation": "Übersetzung für dieses Feld ein- oder ausschalten",
        "backoffice.forms.tooltip.changecurrentlang": "Aktuelle Sprachumgebung wechseln",
        "backoffice.forms.tooltip.addtofavorites": "Zu meinen Favoriten hinzufügen",
        "backoffice.forms.tooltip.removefromfavorites": "Von meinen Favoriten entfernen",
        "backoffice.forms.tooltip.setasafavorite": "Als Favorit gesetzt"
    };
}
exports.backofficeForms_de_de = backofficeForms_de_de;
